// Audience-paced navigation exposed to plugin iframes (SDK `xprops.audienceSlideNavigation`,
// `xprops.audienceNextSlide`, `xprops.audiencePrevSlide`). The plugin asks; Presentation moves with
// the same selfPaceNextSlide / selfPacePrevSlide its AudiencePacingNavigation bar uses.

// EventBus event SlidePluginContent emits and Presentation handles; payload 'next' | 'prev'.
export const AUDIENCE_PACING_NAVIGATE = 'audiencePacingNavigate'

// The participant's position, in the SDK's AudienceSlideNavigation shape.
export const audienceSlideNavigationFor = ({ audiencePacing, slides, slideId }) => {
  const list = Array.isArray(slides) ? slides : []
  const index = list.findIndex((item) => item && item.id === slideId)
  const enabled = Boolean(audiencePacing) && index !== -1
  return {
    enabled,
    index: Math.max(index, 0),
    total: list.length,
    canGoBack: enabled && index > 0,
    canGoNext: enabled && index < list.length - 1,
  }
}

export const HIDE_AUDIENCE_PACING_NAV_FLAG = 'SLPV-258-hide-audience-pacing-nav'

// Manifest `setting.hideAudiencePacingNavigation`: the slide draws its own Next/Back from the SDK
// nav props. A retake player keeps its bar, whose Next on the last slide opens the retake result.
export const hidesAudiencePacingNavigation = ({
  flagEnabled, audiencePacing, isRetakePlayer, setting,
}) => Boolean(
  flagEnabled && audiencePacing && !isRetakePlayer && setting?.hideAudiencePacingNavigation,
)

export default {
  AUDIENCE_PACING_NAVIGATE, HIDE_AUDIENCE_PACING_NAV_FLAG, audienceSlideNavigationFor, hidesAudiencePacingNavigation,
}
